// Search here. https://remixicon.com/

export const icons = {
  "afs-excel-ui": "ri-file-excel-2-line",
};
